import React from "react";
import { useTranslation } from "react-i18next";

import { useAppApi } from "@/App";
import { ExportButton } from "@components/Common/Button";
import { RenderForm } from "@components/Forms/Render";
import { ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function KeysReport() {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:finstatements:keys_report"));

    if (!apiData) return;

    const headerTools = apiData.forms_data && (
        <ExportButton
            size="sm"
            buildReport="xlsx"
            prms={{
                "main-merchant": apiData.forms_data.main.data.merchant,
                "main-purchase_type": apiData.forms_data.main.data.purchase_type,
                "main-upload_date_range": apiData.forms_data.main.data.upload_date_range,
                "main-sale_date_range": apiData.forms_data.main.data.sale_date_range,
            }}
            buttonText={t("Сформировать и скачать отчет")}
        />
    );

    return (
        <ListingCard header={t("Отчет по ключам (API/Stock)")} headerTools={headerTools}>
            <RenderForm bareForm={true} submitMethod="get" />
        </ListingCard>
    );
}
